import { StorageLikesType } from "@components/utils/constants";
import { ITag } from "@modules/requestAQuote/components/TripPreferences";

interface IOnClick {
  (): void;
  (tagData: ITag, tagType?: string): void;
}

interface IActiveTagProps {
  tagData: ITag;
  onClick?: IOnClick;
  isOnResultsPage?: boolean;
  isPopUpTag?: boolean;
  isMobile?: boolean;
  RaQSection?: StorageLikesType;
  isFormB?: boolean;
}

function ActiveTag({
  tagData,
  onClick,
  isOnResultsPage,
  isPopUpTag,
  isMobile,
  RaQSection,
  isFormB,
}: IActiveTagProps): JSX.Element {
  return (
    <div
      onClick={(e) => {
        if (isPopUpTag && onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
      className={`align-center flex cursor-default bg-[#E3E8EF] text-[#364152] ${
        isFormB ? "" : "m-1"
      } min-h-[28px] rounded-full`}
    >
      <div className="flex items-center">
        <div
          className={`${isPopUpTag ? "cursor-pointer px-3" : "pl-3"} ${
            onClick ? "" : "pr-3"
          } text-p ${
            isOnResultsPage ? "overflow-hidden text-clip whitespace-nowrap" : ""
          }`}
          style={{
            maxWidth: isOnResultsPage ? "30ch" : "",
          }}
        >
          {tagData?.Title?.substring(0, 30) ||
            tagData?.title?.substring(0, 30) ||
            ""}
        </div>
        {!isPopUpTag && onClick && (
          <div
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={async (e) => {
              if (isMobile) {
                e.stopPropagation();
              }
              onClick(tagData, RaQSection);
            }}
            className="cursor-pointer px-2 pt-[3px]"
          >
            &#10005;
          </div>
        )}
      </div>
    </div>
  );
}

export default ActiveTag;
